import { useFlow } from '@edreamsodigeo/frontend-core';
export const MOBILE_CLIENT_INTERFACE = 'ONE_FRONT_SMARTPHONE';
export const DESKTOP_CLIENT_INTERFACE = 'ONE_FRONT_DESKTOP';
const MOBILE_FLOW = 'mobile';
export const useFlowTools = () => {
  const flow = useFlow();
  const isMobile = flow === MOBILE_FLOW;
  return { isMobile, isDesktop: !isMobile };
};
